import { PayloadAction } from "@reduxjs/toolkit"
import { ObjectsStateT } from "../../objects.slice"
import { CreateImageT } from "./objectTypes"
import { updateObjectStyles } from "./updateObjectStyles"

export const createImageBaseAction = (
    state: ObjectsStateT,
    action: PayloadAction<CreateImageT>
) => {
    const object = action.payload.object
    const parentId = action.payload.object.parentId
    const dimensions = action.payload.dimensions
    const fill = action.payload.fill
    const newStyles = updateObjectStyles(object, dimensions)
    if (parentId) {
        state.value = {
            ...state.value,
            [object.id]: {
                ...object,
                styles: newStyles,
                fill: fill,
            },
            [parentId]: {
                ...state.value[parentId],
                childIds: [...state.value[parentId].childIds, object.id],
            },
        }
    } else {
        state.value = {
            ...state.value,
            [object.id]: {
                ...object,
                styles: newStyles,
                fill: fill,
            },
        }
    }
}
